import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const imageGallery = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    navigation: {
      activeView: "",
      activeViewIndex: 0,
      views: []
    },
    secondComponentFlow: false,
    useSecondView: false,
    image_category: "",
    currentImages: null,
    selectedImages: null,
    storageController: {
      recipe: null
    },
    isBackToLibraryApplied: false,
    currentUgcView: 0,
    useSameImage: true
  }
};

export default imageGallery;
